import http from './http';

// TODO: cache this response
const getSessionInfo = () => {
  return http.get('/api/internal/session_info').then(({ data }) => data);
};

const setSessionInformation = () => {
  return getSessionInfo().then(function(info) {
    const user = info.user;

    if (!info.user.guest) {
      // TODO: import and set up mixpanel without `window`
      window.mixpanel.identify(info.user.id);

      window.mixpanel.people.set({
        $email: user.email,
        $first_name: user.firstName,
        $last_name: user.lastName
      });
    }

    return info;
  });
};

const track = (event, attrs) => {
  const customProperties = attrs || {};
  return setSessionInformation()
    .then(info => {
      customProperties.ipAddress = info.ipAddress;

      if (info.partner) {
        customProperties.partner = info.partner.name;
        customProperties.partnerType = info.partner.partnerType;
      }
      window.mixpanel.track(event, customProperties);
    })
    .catch(() => {}); // TODO: log error
};

const trackBooleanSelection = (val, name, attrs) => {
  var state = val === true ? 'Enabled' : 'Disabled';
  // ex: Sports Category Filter Enabled
  return track(name + ' ' + state, attrs).catch(function() {
    return;
  });
};

const trackFilterSelection = (filter, filterType, attrs) => {
  //ex: Sports Category Filter
  var eventName = filter.name + ' ' + filterType + ' Filter';
  return trackBooleanSelection(filter.selected, eventName, attrs);
};

export default {
  track,
  trackBooleanSelection,
  trackFilterSelection
};
